import * as React from "react";
import { useContext } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Context from "../../context";

export default function BuoyIndexSlider({ filledMarkers = {}, replayEnabled, onEnableReplay, onExitReplay, buoysInView, loading }) {
    const { buoyIndex, setBuoyIndex, replayTime, setReplayTime, replayTimeRange } = useContext(Context);

    const filledMarkersArray = Object.keys(filledMarkers).reduce((acc, buoyId) => {
        acc.push(filledMarkers[buoyId]);
        return acc;
    }, []);

    const buoyDataLength = filledMarkersArray[0]?.length || 0;

    if (!replayEnabled) {
        // Always show the button if buoysInView is defined (even if 0)
        if (buoysInView !== undefined) {
            return (
                <Box sx={{
                    position: "absolute",
                    left: 10,
                    bottom: 80,
                    zIndex: 10000,
                    pointerEvents: "auto"
                }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onEnableReplay}
                        disabled={buoysInView === 0 || loading}
                        sx={{
                            fontSize: "10px",
                            padding: "4px 10px",
                            minWidth: 0,
                            textTransform: "none",
                            background: "rgba(0,0,0,0.55)",
                            color: "#ccc",
                            boxShadow: 1,
                            "&:hover": { background: "rgba(0,0,0,0.8)", color: "#fff" },
                        }}
                        startIcon={loading ? <CircularProgress size={12} color="inherit" /> : null}
                    >
                        {loading ? 'Loading…' : `Replay (${buoysInView})`}
                    </Button>
                </Box>
            );
        }
        return <></>;
    }

    // Don't show slider if there's no data or time range
    if (!replayTimeRange || !replayTimeRange.min || !replayTimeRange.max) {
        console.log('Not showing slider - no time range');
        return <></>;
    }

    const handleSliderChange = (event, newTime) => {
        console.log('Slider changed to time:', new Date(newTime).toISOString());
        setReplayTime(newTime);
    };

    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    // Calculate time step (e.g., every 10 minutes)
    const timeStep = 10 * 60 * 1000; // 10 minutes in milliseconds

    return (
        <Box sx={{
            width: 500,
            position: "absolute",
            left: "50%",
            bottom: 80,
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: 3,
            borderRadius: 2,
            zIndex: 10000,
            pointerEvents: "auto"
        }}>
            <Box sx={{ color: 'white', mb: 1, fontSize: '14px', textAlign: 'center' }}>
                {formatTime(replayTime || replayTimeRange.max)}
            </Box>
            <Slider
                aria-label="Time"
                value={replayTime || replayTimeRange.max}
                onChange={handleSliderChange}
                valueLabelDisplay="auto"
                valueLabelFormat={formatTime}
                step={timeStep}
                min={replayTimeRange.min}
                max={replayTimeRange.max}
                sx={{
                    color: "primary.main",
                    '& .MuiSlider-thumb': {
                        width: 20,
                        height: 20,
                    }
                }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', color: 'white', fontSize: '12px', mt: 1 }}>
                <span>{formatTime(replayTimeRange.min)}</span>
                <span>{formatTime(replayTimeRange.max)}</span>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5 }}>
                <Button variant="outlined" color="warning" size="small" onClick={onExitReplay}>
                    Exit Replay
                </Button>
            </Box>
        </Box>
    );
}
